import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Heading2 } from '@/components/blocks/typography';
import { Badge } from '@/components/ui/badge';

interface SectionAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface SectionHeaderProps {
  title: string;
  /** Optional count displayed in a badge after title */
  count?: number;
  className?: string;
  action?: SectionAction;
}

export function SectionHeader({ title, count, className, action }: SectionHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <Heading2 className="text-brand-blue-800">{title}</Heading2>
          {count !== undefined && (
            <Badge variant="secondary" className="rounded-full px-2 py-0.5 text-xs font-bold">
              {count}
            </Badge>
          )}
        </div>
        {action ? (
          <div className="flex flex-wrap items-center gap-2 md:justify-end">
            <Button
              size="sm"
              variant="secondary"
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
